import { Injectable } from '@angular/core';
import { CanDeactivate } from '@angular/router';
import { Observable } from 'rxjs';
import { ModalCancelarComponent } from 'src/app/shared/components/modal-cancelar/modal-cancelar-component';
import { TipoAuditoriaFormComponent } from 'src/app/pages/tipo-auditoria-form/tipo-auditoria-form.component';

@Injectable()
export class TipoAuditoriaGuard implements CanDeactivate<TipoAuditoriaFormComponent> {
  canDeactivate(component: TipoAuditoriaFormComponent): Observable<boolean> | boolean {
    if (component.novoRegistro) {
      if (component.submit) { return true; }
      return component.matDialog.open(ModalCancelarComponent).afterClosed();
    } else { return true; }
  }
}
